exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-partner.js-WebpackMultiOutput";